export const ADD_SIGNATURE_TO_CAMPAIGN_REQUEST = 'ADD_SIGNATURE_TO_CAMPAIGN_REQUEST';
export const ADD_SIGNATURE_TO_CAMPAIGN_SUCCESS = 'ADD_SIGNATURE_TO_CAMPAIGN_SUCCESS';
export const ADD_SIGNATURE_TO_CAMPAIGN_FAILURE = 'ADD_SIGNATURE_TO_CAMPAIGN_FAILURE';

export const REMOVE_SIGNATURE_FROM_CAMPAIGN_REQUEST = 'REMOVE_SIGNATURE_FROM_CAMPAIGN_REQUEST';
export const REMOVE_SIGNATURE_FROM_CAMPAIGN_SUCCESS = 'REMOVE_SIGNATURE_FROM_CAMPAIGN_SUCCESS';
export const REMOVE_SIGNATURE_FROM_CAMPAIGN_FAILURE = 'REMOVE_SIGNATURE_FROM_CAMPAIGN_FAILURE';

export const FETCH_CAMPAIGN_SIGNATURES_REQUEST = 'FETCH_CAMPAIGN_SIGNATURES_REQUEST';
export const FETCH_CAMPAIGN_SIGNATURES_SUCCESS = 'FETCH_CAMPAIGN_SIGNATURES_SUCCESS';
export const FETCH_CAMPAIGN_SIGNATURES_FAILURE = 'FETCH_CAMPAIGN_SIGNATURES_FAILURE';

export const FETCH_USER_SIGNATURES_REQUEST = 'FETCH_USER_SIGNATURES_REQUEST';
export const FETCH_USER_SIGNATURES_SUCCESS = 'FETCH_USER_SIGNATURES_SUCCESS';
export const FETCH_USER_SIGNATURES_FAILURE = 'FETCH_USER_SIGNATURES_FAILURE';



// WEBPACK FOOTER //
// ./src/redux/constants/signature.js